import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./sticky-scroll-list.css";

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".element-stickyscrolllist").forEach((el) => {
  const scrollContainer = el.querySelector(".scroll-container");

  gsap.set(el.querySelectorAll(".scroll-list-item"), { opacity: 0.1 });

  const tl = gsap.timeline({
    paused: true,
    scrollTrigger: {
      trigger: scrollContainer,
      start: () => {
        const offset = getComputedStyle(document.documentElement).getPropertyValue("--site-header-stuck-height");

        return `top ${offset}`;
      },
      end: "bottom+=100% center",
      pin: true,
      scrub: true,
      markers: false,
    },
  });

  el.querySelectorAll(".scroll-list-item").forEach((item) => {
    tl.fromTo(item, { opacity: 0.1 }, { opacity: 1 });
  });
});
